import { MarketplaceInfluencersFilterFormValues } from './schemaTypes';

export const defaultMarketplaceInfluencersFilterValues: MarketplaceInfluencersFilterFormValues = {
  minAge: '',
  maxAge: '',
  keyword: '',
  genders: [],
  minFollowers: '',
  maxFollowers: '',
  categoryIds: [],
  minEngagementRate: '',
  maxEngagementRate: '',
  participateStatuses: [],
  talentAgencyOrPartnerIds: []
};
